const Circle = ({ color, type }) => {
  const regular = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99977 2.26668C4.83334 2.26668 2.26644 4.83358 2.26644 8.00002C2.26644 11.1664 4.83334 13.7333 7.99977 13.7333C11.1662 13.7333 13.7331 11.1664 13.7331 8.00002C13.7331 4.83358 11.1662 2.26668 7.99977 2.26668ZM0.933105 8.00002C0.933105 4.0972 4.09696 0.93335 7.99977 0.93335C11.9026 0.93335 15.0664 4.0972 15.0664 8.00002C15.0664 11.9028 11.9026 15.0667 7.99977 15.0667C4.09696 15.0667 0.933105 11.9028 0.933105 8.00002Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Circle;
